import { render, staticRenderFns } from "./telecomCardOrder.vue?vue&type=template&id=0dbf36d3"
import script from "./telecomCardOrder.vue?vue&type=script&lang=js"
export * from "./telecomCardOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports